export const countries_list = [
	{ id: 245, name: 'United States of America' },
	{ id: 1, name: 'Afghanistan' },
	{ id: 3, name: 'Albania' },
	{ id: 4, name: 'Algeria' },
	{ id: 6, name: 'Andorra' },
	{ id: 7, name: 'Angola' },
	{ id: 8, name: 'Anguilla' },
	{ id: 9, name: 'Antarctica' },
	{ id: 10, name: 'Antigua and Barbuda' },
	{ id: 11, name: 'Argentina' },
	{ id: 12, name: 'Armenia' },
	{ id: 13, name: 'Aruba' },
	{ id: 15, name: 'Australia' },
	{ id: 16, name: 'Austria' },
	{ id: 17, name: 'Azerbaijan' },
	{ id: 18, name: 'Bahamas' },
	{ id: 19, name: 'Bahrain' },
	{ id: 20, name: 'Bangladesh' },
	{ id: 21, name: 'Barbados' },
	{ id: 22, name: 'Belarus' },
	{ id: 23, name: 'Belgium' },
	{ id: 24, name: 'Belize' },
	{ id: 25, name: 'Benin' },
	{ id: 26, name: 'Bermuda' },
	{ id: 27, name: 'Bhutan' },
	{ id: 28, name: 'Bolivia (Plurinational State of)' },
	{ id: 29, name: 'Bosnia and Herzegovina' },
	{ id: 30, name: 'Botswana' },
	{ id: 32, name: 'Brazil' },
	{ id: 33, name: 'British Indian Ocean Territory' },
	{ id: 34, name: 'Virgin Islands (British)' },
	{ id: 35, name: 'Brunei Darussalam' },
	{ id: 36, name: 'Bulgaria' },
	{ id: 37, name: 'Burkina Faso' },
	{ id: 38, name: 'Burundi' },
	{ id: 39, name: 'Cambodia' },
	{ id: 40, name: 'Cameroon' },
	{ id: 41, name: 'Canada' },
	{ id: 43, name: 'Cabo Verde' },
	{ id: 45, name: 'Cayman Islands' },
	{ id: 46, name: 'Central African Republic' },
	{ id: 48, name: 'Chad' },
	{ id: 49, name: 'Chile' },
	{ id: 50, name: 'China' },
	{ id: 51, name: 'Christmas Island' },
	{ id: 53, name: 'Cocos (Keeling) Islands' },
	{ id: 54, name: 'Colombia' },
	{ id: 55, name: 'Comoros' },
	{ id: 56, name: 'Congo (Democratic Republic of the)' },
	{ id: 57, name: 'Congo' },
	{ id: 58, name: 'Cook Islands' },
	{ id: 59, name: 'Costa Rica' },
	{ id: 60, name: "Côte d'Ivoire" },
	{ id: 61, name: 'Croatia' },
	{ id: 62, name: 'Cuba' },
	{ id: 63, name: 'Curaçao' },
	{ id: 64, name: 'Cyprus' },
	{ id: 65, name: 'Czech Republic' },
	{ id: 66, name: 'Denmark' },
	{ id: 68, name: 'Djibouti' },
	{ id: 69, name: 'Dominica' },
	{ id: 70, name: 'Dominican Republic' },
	{ id: 71, name: 'Ecuador' },
	{ id: 72, name: 'Egypt' },
	{ id: 73, name: 'El Salvador' },
	{ id: 74, name: 'Equatorial Guinea' },
	{ id: 75, name: 'Eritrea' },
	{ id: 76, name: 'Estonia' },
	{ id: 77, name: 'Ethiopia' },
	{ id: 78, name: 'Falkland Islands (Malvinas)' },
	{ id: 79, name: 'Faroe Islands' },
	{ id: 80, name: 'Fiji' },
	{ id: 81, name: 'Finland' },
	{ id: 82, name: 'France' },
	{ id: 84, name: 'French Polynesia' },
	{ id: 86, name: 'Gabon' },
	{ id: 87, name: 'Gambia' },
	{ id: 88, name: 'Georgia' },
	{ id: 89, name: 'Germany' },
	{ id: 90, name: 'Ghana' },
	{ id: 91, name: 'Gibraltar' },
	{ id: 92, name: 'Greece' },
	{ id: 93, name: 'Greenland' },
	{ id: 94, name: 'Grenada' },
	{ id: 97, name: 'Guatemala' },
	{ id: 98, name: 'Guernsey' },
	{ id: 99, name: 'Guinea' },
	{ id: 100, name: 'Guinea-Bissau' },
	{ id: 101, name: 'Guyana' },
	{ id: 102, name: 'Haiti' },
	{ id: 104, name: 'Honduras' },
	{ id: 105, name: 'Hong Kong' },
	{ id: 106, name: 'Hungary' },
	{ id: 107, name: 'Iceland' },
	{ id: 108, name: 'India' },
	{ id: 109, name: 'Indonesia' },
	{ id: 110, name: 'Iran (Islamic Republic of)' },
	{ id: 111, name: 'Iraq' },
	{ id: 112, name: 'Ireland' },
	{ id: 113, name: 'Isle of Man' },
	{ id: 114, name: 'Israel' },
	{ id: 115, name: 'Italy' },
	{ id: 116, name: 'Jamaica' },
	{ id: 117, name: 'Japan' },
	{ id: 118, name: 'Jersey' },
	{ id: 119, name: 'Jordan' },
	{ id: 120, name: 'Kazakhstan' },
	{ id: 121, name: 'Kenya' },
	{ id: 122, name: 'Kiribati' },
	{ id: 124, name: 'Kuwait' },
	{ id: 125, name: 'Kyrgyzstan' },
	{ id: 126, name: "Lao People's Democratic Republic" },
	{ id: 127, name: 'Latvia' },
	{ id: 128, name: 'Lebanon' },
	{ id: 129, name: 'Lesotho' },
	{ id: 130, name: 'Liberia' },
	{ id: 131, name: 'Libya' },
	{ id: 132, name: 'Liechtenstein' },
	{ id: 133, name: 'Lithuania' },
	{ id: 134, name: 'Luxembourg' },
	{ id: 135, name: 'Macao' },
	{ id: 136, name: 'Macedonia (the former Yugoslav Republic of)' },
	{ id: 137, name: 'Madagascar' },
	{ id: 138, name: 'Malawi' },
	{ id: 139, name: 'Malaysia' },
	{ id: 140, name: 'Maldives' },
	{ id: 141, name: 'Mali' },
	{ id: 142, name: 'Malta' },
	{ id: 145, name: 'Mauritania' },
	{ id: 146, name: 'Mauritius' },
	{ id: 147, name: 'Mayotte' },
	{ id: 148, name: 'Mexico' },
	{ id: 150, name: 'Moldova (Republic of)' },
	{ id: 151, name: 'Monaco' },
	{ id: 152, name: 'Mongolia' },
	{ id: 153, name: 'Montenegro' },
	{ id: 154, name: 'Montserrat' },
	{ id: 155, name: 'Morocco' },
	{ id: 156, name: 'Mozambique' },
	{ id: 157, name: 'Myanmar' },
	{ id: 158, name: 'Namibia' },
	{ id: 159, name: 'Nauru' },
	{ id: 160, name: 'Nepal' },
	{ id: 161, name: 'Netherlands' },
	{ id: 162, name: 'New Caledonia' },
	{ id: 163, name: 'New Zealand' },
	{ id: 164, name: 'Nicaragua' },
	{ id: 165, name: 'Niger' },
	{ id: 166, name: 'Nigeria' },
	{ id: 167, name: 'Niue' },
	{ id: 170, name: "Korea (Democratic People's Republic of)" },
	{ id: 171, name: 'Norway' },
	{ id: 172, name: 'Oman' },
	{ id: 173, name: 'Pakistan' },
	{ id: 175, name: 'Palestine, State of' },
	{ id: 176, name: 'Panama' },
	{ id: 177, name: 'Papua New Guinea' },
	{ id: 178, name: 'Paraguay' },
	{ id: 179, name: 'Peru' },
	{ id: 180, name: 'Philippines' },
	{ id: 181, name: 'Pitcairn' },
	{ id: 182, name: 'Poland' },
	{ id: 183, name: 'Portugal' },
	{ id: 185, name: 'Qatar' },
	{ id: 186, name: 'Réunion' },
	{ id: 187, name: 'Romania' },
	{ id: 188, name: 'Russian Federation' },
	{ id: 189, name: 'Rwanda' },
	{ id: 190, name: 'Saint Barthélemy' },
	{ id: 191, name: 'Saint Helena, Ascension and Tristan da Cunha' },
	{ id: 192, name: 'Saint Kitts and Nevis' },
	{ id: 193, name: 'Saint Lucia' },
	{ id: 194, name: 'Saint Martin (French part)' },
	{ id: 195, name: 'Saint Pierre and Miquelon' },
	{ id: 196, name: 'Samoa' },
	{ id: 197, name: 'San Marino' },
	{ id: 198, name: 'Sao Tome and Principe' },
	{ id: 199, name: 'Saudi Arabia' },
	{ id: 200, name: 'Senegal' },
	{ id: 201, name: 'Serbia' },
	{ id: 202, name: 'Seychelles' },
	{ id: 203, name: 'Sierra Leone' },
	{ id: 204, name: 'Singapore' },
	{ id: 205, name: 'Sint Maarten (Dutch part)' },
	{ id: 206, name: 'Slovakia' },
	{ id: 207, name: 'Slovenia' },
	{ id: 208, name: 'Solomon Islands' },
	{ id: 209, name: 'Somalia' },
	{ id: 210, name: 'South Africa' },
	{ id: 212, name: 'Korea (Republic of)' },
	{ id: 213, name: 'South Sudan' },
	{ id: 214, name: 'Spain' },
	{ id: 215, name: 'Sri Lanka' },
	{ id: 216, name: 'Saint Vincent and the Grenadines' },
	{ id: 217, name: 'Sudan' },
	{ id: 218, name: 'Suriname' },
	{ id: 219, name: 'Svalbard and Jan Mayen' },
	{ id: 220, name: 'Swaziland' },
	{ id: 221, name: 'Sweden' },
	{ id: 222, name: 'Switzerland' },
	{ id: 223, name: 'Syrian Arab Republic' },
	{ id: 224, name: 'Taiwan' },
	{ id: 225, name: 'Tajikistan' },
	{ id: 226, name: 'Tanzania, United Republic of' },
	{ id: 227, name: 'Thailand' },
	{ id: 228, name: 'Timor-Leste' },
	{ id: 229, name: 'Togo' },
	{ id: 230, name: 'Tokelau' },
	{ id: 231, name: 'Tonga' },
	{ id: 232, name: 'Trinidad and Tobago' },
	{ id: 234, name: 'Tunisia' },
	{ id: 235, name: 'Turkey' },
	{ id: 236, name: 'Turkmenistan' },
	{ id: 237, name: 'Turks and Caicos Islands' },
	{ id: 238, name: 'Tuvalu' },
	{ id: 241, name: 'Uganda' },
	{ id: 242, name: 'Ukraine' },
	{ id: 243, name: 'United Arab Emirates' },
	{ id: 244, name: 'United Kingdom of Great Britain and Northern Ireland' },
	{ id: 246, name: 'Uruguay' },
	{ id: 247, name: 'Uzbekistan' },
	{ id: 248, name: 'Vanuatu' },
	{ id: 249, name: 'Holy See' },
	{ id: 250, name: 'Venezuela (Bolivarian Republic of)' },
	{ id: 251, name: 'Viet Nam' },
	{ id: 252, name: 'Wallis and Futuna' },
	{ id: 253, name: 'Western Sahara' },
	{ id: 254, name: 'Yemen' },
	{ id: 255, name: 'Zambia' },
	{ id: 256, name: 'Zimbabwe' },
	{ id: 257, name: 'Åland Islands' },
	{ id: 258, name: 'Bonaire, Sint Eustatius and Saba' },
	{ id: 259, name: 'Bouvet Island' },
	{ id: 261, name: 'French Guiana' },
	{ id: 262, name: 'French Southern Territories' },
	{ id: 263, name: 'Guadeloupe' },
	{ id: 264, name: 'Heard Island and McDonald Islands' },
	{ id: 265, name: 'Martinique' },
	{ id: 266, name: 'Norfolk Island' },
	{ id: 267, name: 'Republic of Kosovo' },
	{ id: 268, name: 'South Georgia and the South Sandwich Islands' },
];

export const blocked_countries = [
	1, 7, 15, 17, 28, 29, 34, 36, 37, 40, 41, 46, 56, 60, 62, 77, 102, 110, 111, 116, 124, 126, 128, 131, 141, 151, 156,
	157, 160, 164, 166, 170, 177, 188, 200, 209, 210, 213, 217, 223, 242, 250, 251, 254, 256,
];
